import { useState, useEffect } from 'react'
import { getEmpsPositionAPI } from '../services/employee'

function UseEmpsPosition(orgId, searchs, dsId, dmId, teamId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEmpsPositionAPI({
        orgId,
        searchs,
        dsId,
        dmId,
        teamId
      })
      if (!result) return
      if (result.status) {
        const newData = result.result.map((d, i) => {
          return {
            value: d?.position_id,
            label: `${d?.position}`
          }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs, dsId, dmId, teamId])

  return data
}

export default UseEmpsPosition
